import { render, staticRenderFns } from "./currencyPopup.vue?vue&type=template&id=905e91de&scoped=true&"
import script from "./currencyPopup.ts?vue&type=script&lang=js&"
export * from "./currencyPopup.ts?vue&type=script&lang=js&"
import style0 from "./currencyPopup.less?vue&type=style&index=0&id=905e91de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e91de",
  null
  
)

export default component.exports